export default __webpack_public_path__ + "static/image7-28af4ced64f09fc0e4718568c18ec933.jpg";